<template>
	<AppModal
		v-bind="$attrs"
		:isFullscreen="true"
		@close="$emit('close')"
		:close="close"
		:z-index="zIndex"
		:is-lg="isLg"
		:not-padding-body="notPaddingBody"
		:isVisible="isVisible"
	>
		<template #header v-if="$slots.header">
			<slot name="header" />
		</template>
		<slot />
		<template #footer-top v-if="$slots['footer-top']">
			<slot name="footer-top" />
		</template>
		<template #footer v-if="$slots.footer">
			<slot name="footer" />
		</template>
	</AppModal>
</template>

<script>
import AppModal from './AppModal.vue'

export default {
	name: 'AppFullscreenModal',
	components: { AppModal },
	emits: ['close'],
	inheritAttrs: false, // para controlar el paso de props
	props: {
		// puedes dejar los props principales, pero con $attrs pasas los extras
		title: { type: String, default: '' },
		close: { type: Boolean, default: false },
		zIndex: {
			type: Number,
			default: null
		},
		isLg: {
			type: Boolean,
			default: false
		},
		notPaddingBody: {
			type: Boolean,
			default: false
		},
		isVisible: {
			type: Boolean,
			default: true
		}
	}
}
</script>
